import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';
import { LAUNCH_STAGE } from '../constants';

export const defaultState: Types.IGameLauncherState = {
    launchData: null,
    launchStage: LAUNCH_STAGE.closed
};

export const reducer = produce((draftState, action: Types.TGameLauncherAction): Types.IGameLauncherState | void => {
    switch (action.type) {
        case actionTypes.START_LAUNCH_PROCESS: {
            Object.assign(draftState, {
                launchData: action.payload,
                launchStage: LAUNCH_STAGE.start
            });

            break;
        }

        case actionTypes.UPDATE_LAUNCH_STAGE: {
            if (!draftState.launchData) {
                return;
            }

            draftState.launchStage = action.payload;

            break;
        }

        case actionTypes.FINISH_LAUNCH_PROCESS: {
            Object.assign(draftState, defaultState);

            break;
        }

        default:
            break;
    }
}, defaultState);
